


















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Products extends Vue {
  public data = [
    {
      heading: 'Prodej autodílů',
      about:
        'Nabízíme prodej <b>značkových autodílů</b> téměř na všechna vozidla za příznivé ceny. Díly zajistíme dle požadavků zákazníka <b>nejpozději do druhého dne</b>.'
    },
    {
      heading: 'Prodej moto dílů a doplňků',
      about:
        'Najdete u nás skladem všechny značkové filtry <b>Hiflo</b>, plasty, chrániče, rukojeti, blinkry a spoustu dalších.<br>Zajišťujeme také olejový servis značky <b>Castrol</b>, <b>Motul</b>, <b>Eurol</b>, <b>Valvoline</b> a <b>Repsol</b>. Jsme <b>autorizovaným prodejcem</b> značkového moto oblečení a příslušenství <b>značky MBW</b>.'
    },
    {
      heading: 'Olejový servis',
      about:
        'Velký výběr značkových olejů pro <b>automobily</b>, <b>motocykly</b> a <b>zahradní techniku</b>. V nabídce také <b>strojní oleje a tuky</b>.<br>Skladem značky <b>Castrol</b>, <b>Shell</b>, <b>Motul</b>, <b>Eurol</b>, <b>Valvoline</b>, <b>Trysk</b>, <b>Mogul</b> a <b>Repsol</b>.'
    },
    {
      heading: 'Prodej a servis mobilních telefonů',
      about:
        'Jsme oficiálním prodejcem mobilních telefonů značky <b>Aligator</b>. Poskytujeme jak <b>záruční</b>, tak i <b>pozáruční servis</b>. Pozáruční servis provádíme na všechny značky mobilních telefonů v <b>nejkratší možné lhůtě</b> a to za <b>velmi příznivé ceny</b>. ' +
        'Mezi nejběžnější servisní úkony patří <b>výměna LCD</b>, <b>výměna akumulátoru</b>, <b>oprava nabíjení</b> a podobně.'
    }
  ];
}
